export default __webpack_public_path__ + "static/vadym-myronov-d45867402cb1db1910a7360175d0a700.png";